module.exports = __webpack_public_path__ + "static/media/authentic.b2cdd113.png";